import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tooltip', 'slider']

  initialize() {
    this.setSliderBackground()
    this.handleTooltip()
  }

  handleTooltip() {
    this.tooltipTarget.innerText = this.sliderTarget.value
    this.tooltipTarget.style.transform = `translateX(${this.sliderFillingPercentage()}%)`
  }

  setSliderBackground() {
    this.sliderTarget.style.backgroundSize = this.sliderFillingPercentage() + '% 100%'
  }

  sliderFillingPercentage() {
    const slider = this.sliderTarget
    const min = slider.min
    const max = slider.max
    const val = slider.value

    return ((val - min) * 100) / (max - min)
  }
}
